import { MediaProgressPayload, ProgressPayload } from '../types';
import { fetchResource } from './authClient';
import { baseUrl } from './baseUrlProvider';

const BASE_URL = baseUrl(window.location.hostname);

/**
 * Adds (or replaces) a progress record in the Learn Database
 * @param data
 * @returns
 */
export const saveProgress = (data: ProgressPayload): Promise<any> => {
  return fetchResource(`${BASE_URL}/user/progress`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const saveQuestionProgress = (data: ProgressPayload): Promise<any> => {
  return fetchResource(`${BASE_URL}/user/progress`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify(data),
  });
};

export const trackMediaInteraction = (
  data: MediaProgressPayload
): Promise<any> => {
  return fetchResource(`${BASE_URL}/media/${data.mediaId}/interaction`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-mpegURL',
    },
    body: JSON.stringify(data.data),
  });
};
